import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (key) => key
});

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("nacuii_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("nacuii_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (translations) => {
    if (typeof translations === "string") return translations;
    return translations?.[lang] ?? translations?.en ?? "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
